import { Component, OnInit } from '@angular/core';
import { SidebarService, UsuarioService } from '../../services/service.index';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {
  usuarioNombre: string;
  usuarioApellido: string;
  perId = 0;

  constructor(public sidebar: SidebarService, public usuarioService: UsuarioService) { }

  ngOnInit() {
    const dataUsuario = localStorage.getItem('usuario');

    if (localStorage.getItem('usuario')) {
      this.usuarioNombre = 'Ingresos'; //localStorage.getItem('usuario').split(',')[5].split(':')[1].replace('"', '').replace('"', '');
      this.usuarioApellido = 'Nobis'; //localStorage.getItem('usuario').split(',')[6].split(':')[1].replace('"', '').replace('"', '');
    }
  }
}
